import styled from 'styled-components/macro';
import { themeGet } from '@styled-system/theme-get';

export const StyledWrapper = styled.div`
  margin: 0 auto;
  width: min(587px, 100vw - 40px);
  height: 557px;
  padding: 16px;
  box-shadow: ${themeGet('shadows.card')};
  border-radius: ${themeGet('radii.base')};
  background-color: ${themeGet('colors.white')};
`;

export const StyledScroll = styled.div`
  height: 465px;
  overflow: scroll;
`;

export const StyledHeader = styled.header`
  display: grid;
  grid-gap: 16px;
  grid-template-columns: 1fr 1.8fr 1fr;

  &:not(:last-child) {
    margin-bottom: 16px;
  }
`;

export const StyledInner = styled.div`
  display: block;
`;

export const StyledHeaderLabel = styled.h6`
  margin-bottom: 8px;
  font-weight: ${themeGet('fontWeights.regular')};
  font-size: ${themeGet('fontSizes.xs')}px;
  color: #666;
`;

export const StyledBtn = styled.button`
  display: flex;
  align-items: center;
  padding: 5px 0;
  margin: 0;
  outline: none;
  background: transparent;
  font-weight: ${themeGet('fontWeights.semi')};
  font-size: ${themeGet('fontSizes.sm')}px;
  color: ${themeGet('colors.primary.extra')};

  svg {
    margin-right: 5px;
  }

  &:hover {
    color: ${themeGet('colors.primary.regular')};
  }
`;

export const StyledContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  border: 1px solid rgba(171, 171, 171, 0.3);
  border-radius: 12px;
  padding: 10px 10px 10px 16px;

  &:not(:last-child) {
    margin-bottom: 8px;
  }
`;

export const StyledContentWrap = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledCoinWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
`;

export const StyledCoinLabel = styled.span`
  position: absolute;
  pointer-events: none;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  font-size: 8px;
  font-weight: ${themeGet('fontWeights.semi')};
  color: ${themeGet('colors.text.default')};
`;

export const StyledLabelWrapper = styled.div`
  overflow: hidden;
`;

export const StyledContentLabel = styled.p<{
  right?: boolean;
}>`
  margin-bottom: 2px;
  font-weight: ${themeGet('fontWeights.semi')};
  font-size: ${themeGet('fontSizes.base')}px;
  color: ${themeGet('colors.primary.extra')};
  text-align: ${(props) =>
    props.right ? 'right' : 'left'};
`;

export const StyledContentText = styled.span`
  display: flex;
  align-items: center;
  font-weight: ${themeGet('fontWeights.regular')};
  font-size: ${themeGet('fontSizes.xs')}px;
  color: ${themeGet('colors.primary.extra')};

  > svg {
    margin-left: 6px;
  }
`;
